<svg height="20" width="60" xmlns="http://www.w3.org/2000/svg">
  <circle r="4" cx="10" cy="10" />
  <circle r="4" cx="30" cy="10" />
  <circle r="4" cx="50" cy="10" />
</svg>
